// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string } from 'prop-types'

const triggerStyles = {
  boxShadow: '0 0 .125em  #000',
}

const PassiveTrigger = props => {
  const {
    columnKey,
    idRoot,
    passiveSummary,
    TooltipTrigger,
  } = props

  if (!passiveSummary.length) {
    return null
  }

  return (
    <TooltipTrigger
      idRoot={idRoot}
      tooltipColumn={columnKey}
      tooltipData={passiveSummary}>
      <span
        className={'tooltip-trigger-decoration show-decoration'}
        data-label={'path-passive-trigger'}
        style={triggerStyles}>
        {'P'}
      </span>
    </TooltipTrigger>
  )
}

PassiveTrigger.propTypes = {
  columnKey: string.isRequired,
  idRoot: string.isRequired,
  passiveSummary: array.isRequired,
  TooltipTrigger: func.isRequired,
}

export default PassiveTrigger
